import { supabase } from '../supabase';

export interface AgentContact {
  id: number;
  user_id: number;
  phone_number: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  user?: {
    first_name: string | null;
    last_name: string | null;
    exporter_id: number | null;
    exporter?: {
      name: string;
    } | null;
  } | null;
}

export interface AgentMessage {
  id: number;
  contact_id: number | null;
  user_id: number | null;
  channel: 'whatsapp' | 'web';
  role: 'user' | 'assistant' | 'tool';
  content: string | null;
  tool_calls: any;
  tool_results: any;
  is_compacted: boolean;
  created_at: string;
}

export const getAgentContactsWithUsers = async (): Promise<AgentContact[]> => {
  const { data, error } = await supabase
    .from('agent_whatsapp_contacts')
    .select('*, user:users(first_name, last_name, exporter_id, exporter:exporters(name))')
    .order('updated_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

export const getAgentMessagesByContact = async (
  contactId: number
): Promise<AgentMessage[]> => {
  const { data, error } = await supabase
    .from('agent_messages')
    .select('*')
    .eq('contact_id', contactId)
    .in('role', ['user', 'assistant'])
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data || [];
};
